import React from 'react';
import { ReactNode } from 'react';
import { DataProviderContext, RequestDataProvider } from 'nekst-api';
import * as Sentry from '@sentry/react';

export function SentrySessionDataProvider(props: {
  children: ReactNode,
}) {

  const getReplaySessionId = () => {
    try {
      // Get the current replay instance and extract session ID
      const replay = Sentry.getReplay();
      return replay?.getReplayId() || null;
    } catch {
      return null;
    }
  };

  const sessionId = getReplaySessionId();

  const dataProviders: RequestDataProvider[] = sessionId ? [
    {
      getHeaders: () => ({
        'X-Sentry-Session-Id': sessionId,
      }),
    },
  ] : [];

  return (
    <DataProviderContext data={dataProviders}>
      {props.children}
    </DataProviderContext>
  );
}
